import React from "react";
import { HeaderModule } from '../../../components/home/HeaderModule';
import { HubOutlined } from "@mui/icons-material";
import { ActionsBar } from "../../../components/ActionsBar";
import { TableModule } from "../../../components/home/TableModule";
import { useResponses } from "../../../hooks/encuestas/useResponses";

export const Responses = () => {

    const { columns, responses, searchResponses, total } = useResponses(true);

    return (
        <>
            <HeaderModule 
                icon={ <HubOutlined htmlColor="rgba(0, 0, 0, .6)" /> }
                title='Respuestas'
            />

            <ActionsBar
                searchAction={ searchResponses } 
                searchPlaceholder='Código encuesta'
            />

            <TableModule
                columns={ columns }
                rows={ responses }
                styles={{
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10,
                }}
                total={ total }
            />
        </>
    )
}